import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.93 3.885a1.315 1.315 0 0 0-1.858 0L6.51 10.447a1.315 1.315 0 0 0 1.858 1.859l4.323-4.324v15.205c0 .726.586 1.313 1.313 1.313.726 0 1.312-.587 1.312-1.313V7.982l4.323 4.324a1.315 1.315 0 0 0 1.858-1.859l-6.562-6.562z"
    }, null, -1)
  ]))]))
}
export default { render: render }